import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
// import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

const IdentifyPage = props => {
  return (
    <EducationModuleLayout
      progressStage={3}
      childTitle="Identify"
      progressType="identify"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-purple no-bold no-margin">Behaviours, Thoughts and Feelings: What to look for </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                Examples of behaviours, thoughts, and feelings that occur {' '}
                <strong>all of a sudden</strong> can include:
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <ul className="list-group">
                <li className="list-group-item">
                  aggressive or disruptive behavior
                </li>
                <li className="list-group-item">unprovoked outbursts</li>
                <li className="list-group-item">
                  incongruent emotional reactions (e.g., inappropriate laughter, unexplained crying)
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-purple previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer
                to={url.IDENTIFY_D}
                className="next btn btn-purple"
              >
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyB = IdentifyPage;
export default connect.role(IdentifyB);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyC/index.jsx